import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';

const useStyles = makeStyles({
  card: {
    borderRadius: 6,
    overflow: 'hidden',
    cursor: 'pointer',
    border: '2px solid transparent',
    transition: 'border-color 0.2s ease',
  },
  cardSelected: {
    border: '2px solid #1ab7ea',
  },
  thumbnail: {
    width: '100%',
    display: 'block',
    aspectRatio: '16 / 9',
    objectFit: 'cover',
  },
  title: {
    fontSize: 12,
    padding: '4px 6px',
    lineHeight: 1.3,
    overflow: 'hidden',
    display: '-webkit-box',
    WebkitLineClamp: 2,
    WebkitBoxOrient: 'vertical',
  },
});

export const VimeoVideoCard = ({ video, isSelected, onSelect }) => {
  const classes = useStyles();

  return (
    <Box
      className={`${classes.card} ${isSelected ? classes.cardSelected : ''}`}
      onClick={() => onSelect(video)}
    >
      <img
        className={classes.thumbnail}
        src={video.thumbnail}
        alt={video.title}
        loading="lazy"
      />
      <div className={classes.title}>{video.title}</div>
    </Box>
  );
};

VimeoVideoCard.defaultProps = {
  isSelected: false,
  onSelect: () => {},
};
